"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("@loadsure/utils");
const invoiceLineItem_1 = __importDefault(require("./invoiceLineItem"));
const invoicePartner_1 = __importDefault(require("./invoicePartner"));
const invoiceSummary_1 = __importDefault(require("./invoiceSummary"));
class Invoice extends invoiceSummary_1.default {
    constructor(partner, date, billingPeriod, currency, grossPremium, serviceFee, tax, commission, totalCreditCard, netAmountDue, version, lineItems) {
        super(partner.id, date, billingPeriod, currency, grossPremium, serviceFee, tax, commission, totalCreditCard, netAmountDue, version);
        this.partner = partner;
        this.lineItems = lineItems;
    }
    static fromObj(data) {
        var _a, _b, _c;
        const lineItems = data.version !== 2 &&
            Array.isArray(data.lineItems) &&
            data.lineItems.length
            ? data.lineItems.map(invoiceLineItem_1.default.fromObj)
            : [];
        return new Invoice(invoicePartner_1.default.fromObj(data.partner), data.date, utils_1.ISODatePeriod.fromObj(data.billingPeriod), data.currency || "", data.grossPremium, data.serviceFee, (_a = data.tax) !== null && _a !== void 0 ? _a : data.taxesAndFees, data.commission, (_b = data.totalCreditCard) !== null && _b !== void 0 ? _b : 0, data.netAmountDue, (_c = data.version) !== null && _c !== void 0 ? _c : 1, lineItems);
    }
}
exports.default = Invoice;
//# sourceMappingURL=invoice.class.js.map